export const GET_ALLOYWIDTHS_STATED = 'GET_ALLOYWIDTHS_STATED';
export const GET_ALLOYWIDTHS = 'GET_ALLOYWIDTHS';
export const GET_ALLOYWIDTHS_ENDED = 'GET_ALLOYWIDTHS_ENDED';

export const ADD_ALLOYWIDTH_STATED = 'ADD_ALLOYWIDTH_STATED';
export const ADD_ALLOYWIDTH = 'ADD_ALLOYWIDTH';
export const ADD_ALLOYWIDTH_ENDED = 'ADD_ALLOYWIDTH_ENDED';

export const EDIT_ALLOYWIDTH_STATED = 'EDIT_ALLOYWIDTH_STATED';
export const EDIT_ALLOYWIDTH = 'EDIT_ALLOYWIDTH';
export const EDIT_ALLOYWIDTH_ENDED = 'EDIT_ALLOYWIDTH_ENDED';

export const GET_ALLOYWIDTH_STATED = 'GET_ALLOYWIDTH_STATED';
export const GET_ALLOYWIDTH = 'GET_ALLOYWIDTH';
export const GET_ALLOYWIDTH_ENDED = 'GET_ALLOYWIDTH_ENDED';

export const GET_ALL_ALLOYWIDTHS_STATED = 'GET_ALL_ALLOYWIDTHS_STATED';
export const GET_ALL_ALLOYWIDTHS = 'GET_ALL_ALLOYWIDTHS';
export const GET_ALL_ALLOYWIDTHS_ENDED = 'GET_ALL_ALLOYWIDTHS_ENDED';
